import { render, staticRenderFns } from "./PendingMissionDeliverables.vue?vue&type=template&id=0c24f754&"
import script from "./PendingMissionDeliverables.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PendingMissionDeliverables.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports